// eslint-disable-next-line @typescript-eslint/ban-types
export var isIntersection = function (codec) { return '_tag' in codec && codec._tag === 'IntersectionType'; };
